// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2A3D-","content":"styles_content__1cW4v","container_form":"styles_container_form__1s2LY"};